export default __webpack_public_path__ + "static/media/sidebarOpenArrow.23693e09.svg";